import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { putLoanExecute } from '../../infra/api';
import { useBaseParam } from '../hooks/useBaseParam';
import { useBridge } from '../hooks/useBridge';
import useBeacon from '../hooks/useBeacon';
import useEntry from './useEntry';
import { MEDIA_NAME, PAGE_NM } from '../types/types';
import { useRecoilValue } from 'recoil';
import { beaconSelector } from '../recoil/selector';
import { RATE_CALC_BANNER } from '../staticData/Banner/RATE_CALC_BANNER';
import { fetchTotalProductDetail } from '../../infra/api/fetchTotalProductDetail';
import useToast from '../hooks/useToast';
import useNav from '../hooks/useNav';

const useProdPreDetail = () => {
  const { preRequestDtlNo: preRequestDtlNo } = useParams();
  const { pathname } = useLocation();
  const location = pathname.split('/')[2];
  const br = useBridge();
  const { historyBack } = useNav();
  const { media } = useEntry();
  const { addToast } = useToast();
  const [isLoading, setIsLoading] = useState(true);
  const [bridgeModal, setBridgeModal] = useState({
    open: false,
    timeout: 2000,
    message: `에서\n 이어서 신청해 주세요`,
    handleDone: () => {},
  });
  const [preDetailInfo, setPreDetailInfo] = useState<any>({});
  const {
    custPreProductInfo,
    productInfo,
    isAvailableProduct, // 대출 신청 가능 여부
  } = preDetailInfo;

  const [isDisabledMainBtn, setIsDisabledMainBtn] = useState<boolean>(false);
  const [isloanExcuting, setIsLoanExcuting] = useState(false);

  const navigateLink = (landingUrl?: any) => {
    const url = landingUrl || productInfo?.requestLink;
    sendBeaconLandingProduct(url);

    if (productInfo?.detailLinkTypeCd === 'OUT') {
      br.openExternalBrowser({
        url,
      });
    } else if (productInfo?.detailLinkTypeCd === 'IN') {
      br.openNativeWebView({
        url,
        title: '상세보기',
        closeType: 'B',
      });
    }

    setTimeout(goBackPrevPage, 1000);
  };

  const goBackPrevPage = () => {
    if (
      media === MEDIA_NAME.SKT &&
      (location === undefined || location === 'working')
    ) {
      br.close();
    } else {
      historyBack();
    }
  };

  const getTotalProductDetail = useBaseParam(fetchTotalProductDetail, {
    preRequestDtlNo,
  });
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const res = await getTotalProductDetail();
      if (res?.data?.isSucceed === true) {
        setPreDetailInfo(res.data.result);
      }
      setIsLoading(false);
    })();
  }, [preRequestDtlNo]);

  const mutateLoanExecute = useBaseParam(putLoanExecute, {
    preRequestDtlNo: preRequestDtlNo,
  });

  const executeLoan = async () => {
    if (isloanExcuting) return;
    if (isAvailableProduct === false) {
      addToast('해당 금융사 상품이 이미 신청 중입니다.');
      setIsDisabledMainBtn(true);

      return;
    }

    try {
      setIsLoanExcuting(true);
      const result: any = await mutateLoanExecute();
      const landingUrl = result?.data?.result?.landingUrl;
      setBridgeModal((prev) => ({
        ...prev,
        open: true,
        message: `${productInfo?.compNm}에서\n 이어서 신청해 주세요`,
        handleDone: () => {
          setBridgeModal((prev) => ({
            ...prev,
            open: false,
          }));

          if (result.data.isSucceed) {
            navigateLink(landingUrl);
          } else {
            setIsDisabledMainBtn(true);
          }
        },
      }));
    } finally {
      setIsLoanExcuting(false);
    }
  };

  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.PRE_DETAIL,
  });
  useEffect(() => {
    beacon.sendViewPage();
  }, []);
  const sendBeaconExecuteButton = (btnNm: string) => {
    const productSeq = productInfo?.productSeq;
    beacon.sendClkBtnLoanApp({
      properties: { btnNm, productSeq },
    });
  };

  const sendBeaconLandingProduct = (url: string) => {
    const productSeq = productInfo?.productSeq;
    const preRequestDtlNo = custPreProductInfo?.preRequestDtlNo;
    beacon.sendLandingProduct({
      properties: { productSeq, preRequestDtlNo, url },
    });
  };

  const sendBeaconClkBtnIntrstCalc = (btnNm: string) => {
    beacon.sendClkBtnIntrstCalc({
      properties: { btnNm },
    });
  };

  return {
    isLoading,
    productInfo,
    custProductDetailItem: custPreProductInfo,
    hashTagList: productInfo?.hashTagList?.map((item: any) => ({
      color: item.color,
      backgroundColor: item.backgroundColor,
      text: item.tagNm,
    })),
    productOptions: productInfo?.productOptions?.map((item: any) => ({
      title: item.titleTypeCdNm,
      description: item.description,
      key: item.titleTypeCd,
    })),
    isAvailableProduct, // 대출 신청 가능 여부
    executeLoan,
    sendBeaconExecuteButton,
    sendBeaconClkBtnIntrstCalc,
    isDisabledMainBtn,
    bridgeModal,
    RATE_CALC_BANNER,
    calc_item: RATE_CALC_BANNER[0],
  };
};

export default useProdPreDetail;
